"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withHeadersFilter = void 0;
const constants_1 = require("./constants");
const withHeadersFilter = (axiosInstance, allowedHeaders = constants_1.DEFAULT_ALLOWED_HEADERS) => {
    axiosInstance.interceptors.request.use((config) => {
        const lowerCasedAllowedHeaders = allowedHeaders.map(header => header.toLowerCase());
        Object.keys(config.headers).forEach(header => {
            if (!lowerCasedAllowedHeaders.includes(header.toLowerCase())) {
                delete config.headers[header];
            }
        });
        return config;
    });
    return axiosInstance;
};
exports.withHeadersFilter = withHeadersFilter;
//# sourceMappingURL=withHeadersFilter.js.map